import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu",
  "use": "menu-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"menu\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20 8H4V10H20V8ZM20 14H4V16H20V14Z\" fill=\"#424242\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol